import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const StudentSettings = () => {
  const routes = all_routes;
  const [activeTab, setActiveTab] = useState("account");

  const [settings, setSettings] = useState({
    notifications: {
      email: true,
      push: true,
      homework: true,
      grades: true,
      attendance: false,
      events: true,
    },
    privacy: {
      profileVisible: true,
      gradesVisible: false,
      attendanceVisible: true,
    },
    preferences: {
      language: "en",
      theme: "light",
      timezone: "UTC-5",
    },
  });

  const handleNotificationChange = (key: string) => {
    setSettings((prev) => ({
      ...prev,
      notifications: {
        ...prev.notifications,
        [key]: !prev.notifications[key as keyof typeof prev.notifications],
      },
    }));
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Settings</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-secondary">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Account Settings</h3>
                      <p>Manage notifications, privacy and preferences</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-settings text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Settings Content */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "account" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("account")}
                      >
                        <i className="ti ti-user me-2"></i>
                        Account
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "notifications" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("notifications")}
                      >
                        <i className="ti ti-bell me-2"></i>
                        Notifications
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "privacy" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("privacy")}
                      >
                        <i className="ti ti-shield me-2"></i>
                        Privacy
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "preferences" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("preferences")}
                      >
                        <i className="ti ti-settings-2 me-2"></i>
                        Preferences
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  {/* Account Tab */}
                  {activeTab === "account" && (
                    <div>
                      <h5 className="mb-3">Personal Information</h5>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Full Name</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Sarah Johnson"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            defaultValue="sarah.johnson@student.edu"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Phone</label>
                          <input
                            type="tel"
                            className="form-control"
                            defaultValue="+1 (555) 123-4567"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Student ID</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="STU-2024-001"
                            disabled
                          />
                        </div>
                      </div>
                      <hr />
                      <h5 className="mb-3">Change Password</h5>
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Current Password</label>
                          <input type="password" className="form-control" />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">New Password</label>
                          <input type="password" className="form-control" />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Confirm Password</label>
                          <input type="password" className="form-control" />
                        </div>
                      </div>
                      <button className="btn btn-primary">
                        Update Account
                      </button>
                    </div>
                  )}

                  {/* Notifications Tab */}
                  {activeTab === "notifications" && (
                    <div>
                      <h5 className="mb-3">Notification Preferences</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <h6>Delivery Methods</h6>
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={settings.notifications.email}
                              onChange={() => handleNotificationChange("email")}
                            />
                            <label className="form-check-label">
                              Email Notifications
                            </label>
                          </div>
                          <div className="form-check mb-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={settings.notifications.push}
                              onChange={() => handleNotificationChange("push")}
                            />
                            <label className="form-check-label">
                              Push Notifications
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <h6>Content Types</h6>
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={settings.notifications.homework}
                              onChange={() =>
                                handleNotificationChange("homework")
                              }
                            />
                            <label className="form-check-label">
                              Homework Reminders
                            </label>
                          </div>
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={settings.notifications.grades}
                              onChange={() =>
                                handleNotificationChange("grades")
                              }
                            />
                            <label className="form-check-label">
                              Grade Updates
                            </label>
                          </div>
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={settings.notifications.attendance}
                              onChange={() =>
                                handleNotificationChange("attendance")
                              }
                            />
                            <label className="form-check-label">
                              Attendance Alerts
                            </label>
                          </div>
                          <div className="form-check mb-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={settings.notifications.events}
                              onChange={() =>
                                handleNotificationChange("events")
                              }
                            />
                            <label className="form-check-label">
                              School Events
                            </label>
                          </div>
                        </div>
                      </div>
                      <button className="btn btn-primary">
                        Save Notification Settings
                      </button>
                    </div>
                  )}

                  {/* Privacy Tab */}
                  {activeTab === "privacy" && (
                    <div>
                      <h5 className="mb-3">Privacy Settings</h5>
                      <div className="form-check mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultChecked
                        />
                        <label className="form-check-label">
                          Make my profile visible to classmates
                        </label>
                      </div>
                      <div className="form-check mb-3">
                        <input className="form-check-input" type="checkbox" />
                        <label className="form-check-label">
                          Allow parents to view my grades
                        </label>
                      </div>
                      <div className="form-check mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultChecked
                        />
                        <label className="form-check-label">
                          Share attendance with parents
                        </label>
                      </div>
                      <div className="form-check mb-3">
                        <input className="form-check-input" type="checkbox" />
                        <label className="form-check-label">
                          Allow teachers to share my work as examples
                        </label>
                      </div>
                      <button className="btn btn-primary">
                        Update Privacy Settings
                      </button>
                    </div>
                  )}

                  {/* Preferences Tab */}
                  {activeTab === "preferences" && (
                    <div>
                      <h5 className="mb-3">App Preferences</h5>
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Language</label>
                          <select className="form-select" defaultValue="en">
                            <option value="en">English</option>
                            <option value="es">Español</option>
                            <option value="fr">Français</option>
                          </select>
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Theme</label>
                          <select className="form-select" defaultValue="light">
                            <option value="light">Light</option>
                            <option value="dark">Dark</option>
                            <option value="auto">Auto</option>
                          </select>
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Timezone</label>
                          <select className="form-select" defaultValue="UTC-5">
                            <option value="UTC-5">EST (UTC-5)</option>
                            <option value="UTC-6">CST (UTC-6)</option>
                            <option value="UTC-7">MST (UTC-7)</option>
                            <option value="UTC-8">PST (UTC-8)</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-check mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultChecked
                        />
                        <label className="form-check-label">
                          Show dashboard tips
                        </label>
                      </div>
                      <div className="form-check mb-3">
                        <input className="form-check-input" type="checkbox" />
                        <label className="form-check-label">
                          Auto-refresh data every 5 minutes
                        </label>
                      </div>
                      <button className="btn btn-primary">
                        Save Preferences
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentSettings;
